import React from 'react'

import {KebabItem} from './KebabmenuItem.styles'

const KebabmenuItemComponent = ({action, actionType, label, events}) => {
  if (actionType === 'callback') {
    return (
      <KebabItem href='/' onClick={events.handleClick}>
        {label}
      </KebabItem>
    )
  }

  return (
    <KebabItem href={action}>
      {label}
    </KebabItem>
  )
}

export default KebabmenuItemComponent
